import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { GallerySection } from '../components/GallerySection';
import { HookSection } from '../components/HookSection';
import { AgitationSection } from '../components/AgitationSection';
import { BonusesSection } from '../components/BonusesSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FAQSection } from '../components/FAQSection';
import { EmotionalClose } from '../components/EmotionalClose';
import { Footer } from '../components/Footer';
import { PurchaseNotification } from '../components/PurchaseNotification';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initMetaPixel(pixelId: string) {
  if (window.fbq) return;
  const n: any = window.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', pixelId);
}
export function SalesPage() {
  useEffect(() => {
    initMetaPixel('3934337213376403');
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent');
    // Noscript fallback pixel
    const ns = document.createElement('img');
    ns.height = 1;
    ns.width = 1;
    ns.style.display = 'none';
    ns.src = 'https://www.facebook.com/tr?id=3934337213376403&ev=PageView&noscript=1';
    document.body.appendChild(ns);
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-484">
      <AnnouncementBar data-id="element-485" />
      <HeroSection data-id="element-486" />
      <TestimonialsSection data-id="element-487" />
      <ValueStackSection data-id="element-488" />
      <GallerySection data-id="element-489" />
      <HookSection data-id="element-490" />
      <AgitationSection data-id="element-491" />
      <BonusesSection data-id="element-492" />
      <GuaranteeSection data-id="element-493" />
      <UrgencySection data-id="element-494" />
      <FAQSection data-id="element-495" />
      <EmotionalClose data-id="element-496" />
      <Footer data-id="element-497" />
      <PurchaseNotification data-id="element-498" />
    </div>;
}